import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

// STATIC_PAGE_LIST
export const getStaticPageList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      apiendpoints.MANAGE_ALL_STATIC_PAGE
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// STATIC_PAGE_BY_ID
export const getStaticPageByUrl = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_STATIC_PAGE_BY_URL}?url=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// STATIC_PAGE_UPDATE
export const updateStaticPage = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.MANAGE_STATIC_PAGE_UPDATE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
